import { render, staticRenderFns } from "./event-notifications.vue?vue&type=template&id=e097a550&"
import script from "./event-notifications.vue?vue&type=script&lang=js&"
export * from "./event-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports